import { styled } from "@mui/material/styles";
import { useColors } from "../../../../Context/ColorsContext";
import { MediaQuerys } from "../../../../styles/GlobalStyle";

const { tablet } = MediaQuerys;


export const Container = styled('div')(({theme}) => ({
  display: 'flex',
  width: '700px',
  height: 'auto',
  maxHeight: '80vh',
  flexDirection: 'column',
  [theme.breakpoints.down('md')]: {
    width: '70vw',
  },
  [theme.breakpoints.down('sm')]: {
    width: '85vw',
  },
  [theme.breakpoints.up('md')]: {
    width: '700px',
    maxWidth: '700px',
  },
}))

export const Header = styled('div')(({ theme }) => {
  const { colors } = useColors();
  return {
    display: 'flex',
    background: colors.white,
    color: colors.sidebarSelectColor,
    width: '100%',
    height: 'fit-content',
    borderRadius:'10px 10px 0 0',
    padding:'16px',
    textTransform:'uppercase',
    fontWeight:600,
    borderBottom: '1px solid #e4e4e4',
      fontSize: '14px',
    [theme.breakpoints.up('md')]: {
      fontSize: '12px',
    },
  }
})

export const Body = styled('div')(() => {
  const { colors } = useColors();
  return {    
    display: 'flex',
    flexDirection:'column',
    flex:'1',
    width: '100%',
    background: colors.white,
    overflow: 'hidden',
    paddingRight: '8px',
  }
})

export const Footer = styled('div')(() => {
  const { colors } = useColors();
  return {
    display: 'flex',
    background: colors.white,
    width: '100%',
    height: 'fit-content',
    borderRadius:'0 0 10px 10px',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding:'16px',
    margin: 'auto',
    borderTop: '1px solid #e4e4e4',
  }
})

export const SectionRight = styled('section')(() => ({
  display: 'flex',
}))

export const Spacer = styled('section')(() => ({
  padding: '0.5rem',
}))